module.exports = __webpack_public_path__ + "static/img/two_in_one_pos.192c984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/two_in_one_pos.png
// module id = Ir4/
// module chunks = 8